import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Lightning } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';
import LanguageSelector from '../components/LanguageSelector';

const PRO_EMAIL_URL = process.env.REACT_APP_PRO_EMAIL_URL || 'https://pro-email.app/register';

export default function SignupPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground p-6" data-testid="signup-gateway-page">
      <div className="absolute right-6 top-6"><LanguageSelector className="w-32" /></div>
      <div className="w-full max-w-md rounded-xl border border-border bg-background p-8 text-center shadow-sm">
        <div className="mb-6 flex items-center justify-center gap-2">
          <Lightning size={28} weight="fill" />
          <span className="font-heading text-xl font-bold">Mayr Lead Creator</span>
        </div>
        <h1 className="font-heading text-2xl font-bold mb-3">{t('auth.gatewayTitle')}</h1>
        <p className="text-sm text-muted-foreground mb-7">{t('auth.gatewayBody')}</p>
        <Button className="w-full" onClick={() => window.location.assign(PRO_EMAIL_URL)} data-testid="open-pro-email-button">
          {t('auth.openProEmail')}
        </Button>
        <Link to="/signin" className="mt-5 inline-block text-xs text-muted-foreground underline">{t('auth.backToSignin')}</Link>
      </div>
    </div>
  );
}
